import React from 'react'

const DownloadInvoiceModal = ({row}) => {
  return (
    <div>DownloadInvoiceModal</div>
  )
}

export default DownloadInvoiceModal